import request from '@/router/axios';

const urlPrefix = process.env.VUE_APP_LOCAL_DEVELOPMENT == 'false' ? '/wage' : '/wage'

// 工资历史列表数据
export function queryListPageQuery(obj) {
  return request({
    url:  urlPrefix +'/salaryHistory/queryListPageQuery',
    method: 'POST',
    data: obj,
  });
}
// 工资批次删除
export function deleteBatchById(obj) {
  return request({
    url:  urlPrefix +'/wagebatchinfo/deleteWageBatchInfo',
    method: 'POST',
    data: obj,
  });
}

